export const PPOA_QES_TYPE = "Qes";
export const PPOA_FILE_UPLOAD = "FileUpload";
export const PPOA_HALTER_TYPE = "juristische";
